import { useState, useEffect } from "react";
import { BlogSlider } from "../Blog/BlogSlider";
import BlogCardSkeleton from "../Blog/BlogCardSkeleton";
import { getImageUrl, getBlogs } from "src/utils/magnolia";
import BlogItem from "../Blog/BlogItem";

type BlogListProps = {
  taxonomy?: string;
  setPopularList?: any;
};

const BlogList = ({ taxonomy, setPopularList }: BlogListProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [blogs, setBlogs] = useState([]);

  const getBlogList = async () => {
    setIsLoading(true);
    try {
      const { data, status } = await getBlogs({
        params: {
          limit: 5,
          ...(taxonomy !== "" && { taxonomy: taxonomy }),
        },
      });

      if (status == 200) {
        taxonomy === "Terpopuler" && setPopularList(data.results);
        setBlogs(data.results);
        setIsLoading(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getBlogList();
  }, []);

  return (
    <>
      {isLoading ? (
        <BlogSlider>
          <BlogCardSkeleton></BlogCardSkeleton>
        </BlogSlider>
      ) : (
        taxonomy !== "Terpopuler" && (
          <div
            className="blog-card-wrapper"
            style={{ maxWidth: taxonomy === "" ? "626.73px" : "940px" }}
          >
            <BlogSlider>
              {blogs.length > 0 &&
                blogs.map((blog, key) => {
                  return (
                    <div key={key}>
                      <BlogItem
                        key={blog.slug}
                        thumbnail={getImageUrl(blog.thumbnail)}
                        title={blog.title}
                        excerpt={blog.excerpt}
                        slug={blog.slug}
                        taxonomy={blog.taxonomy}
                      />
                    </div>
                  );
                })}
            </BlogSlider>
          </div>
        )
      )}
      <style jsx>{`
        .blog-card-wrapper {
          display: flex;
          width: 100%;
          min-height: 398.6px;
        }
      `}</style>
    </>
  );
};

export default BlogList;
